<!-- Wrapper con scroll -->
<div style="max-height: 65vh; overflow-y: auto; padding-right: 0.25rem;">

<div class="form-header" style="margin-bottom: 1.5rem;">
  <h3 class="form-title" style="font-size: 1.5rem; margin-bottom: 0.5rem;">Verificación en Dos Pasos</h3>
  <p class="form-subtitle" style="font-size: 0.9375rem;">Selecciona tu método de verificación</p>
</div>

<!-- Error Messages -->
<div *ngIf="errors && errors.length > 0" class="error-container" style="margin-bottom: 1.5rem;">
  <div class="error-alert" *ngFor="let error of errors" style="background: #fef2f2; border: 1px solid #fecaca; border-radius: 8px; padding: 1rem; display: flex; gap: 0.625rem; align-items: start;">
    <i class="fas fa-exclamation-triangle" style="color: #dc2626; margin-top: 0.125rem;"></i>
    <span style="color: #991b1b; font-size: 0.875rem;">{{ error.msg }}</span>
  </div>
</div>

<!-- Métodos disponibles -->
<div style="display: flex; flex-direction: column; gap: 1rem; margin-bottom: 1.5rem;">
  
  <!-- Método: Google Authenticator (solo si está en availableMethods) -->
  <button 
    *ngIf="availableMethods.includes('authenticator')"
    type="button" 
    (click)="selectMethod('authenticator')"
    [disabled]="loading"
    style="background: white; border: 2px solid #e5e7eb; border-radius: 12px; padding: 1.25rem; cursor: pointer; transition: all 0.2s; text-align: left; display: flex; align-items: center; gap: 1rem;"
    onmouseover="if(!this.disabled) { this.style.borderColor='#01abce'; this.style.background='#f0f9ff'; }"
    onmouseout="if(!this.disabled) { this.style.borderColor='#e5e7eb'; this.style.background='white'; }">
    
    <div style="background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%); border-radius: 12px; width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
      <i class="fas fa-shield-alt" style="color: white; font-size: 1.5rem;"></i>
    </div>
    
    <div style="flex: 1;">
      <h4 style="font-size: 1rem; font-weight: 600; color: #1f2937; margin: 0 0 0.25rem 0;">Google Authenticator</h4>
      <p style="font-size: 0.875rem; color: #6b7280; margin: 0;">Usa tu app de autenticación</p>
    </div>
    
    <i class="fas fa-chevron-right" style="color: #9ca3af; font-size: 1rem;"></i>
  </button>

  <!-- Método: SMS (solo si está en availableMethods) -->
  <button 
    *ngIf="availableMethods.includes('sms')"
    type="button" 
    (click)="selectMethod('sms')"
    [disabled]="loading"
    style="background: white; border: 2px solid #e5e7eb; border-radius: 12px; padding: 1.25rem; cursor: pointer; transition: all 0.2s; text-align: left; display: flex; align-items: center; gap: 1rem;"
    onmouseover="if(!this.disabled) { this.style.borderColor='#01abce'; this.style.background='#f0f9ff'; }"
    onmouseout="if(!this.disabled) { this.style.borderColor='#e5e7eb'; this.style.background='white'; }">
    
    <div style="background: linear-gradient(135deg, #10b981 0%, #059669 100%); border-radius: 12px; width: 56px; height: 56px; display: flex; align-items: center; justify-content: center; flex-shrink: 0;">
      <i class="fas fa-mobile-alt" style="color: white; font-size: 1.5rem;"></i>
    </div>
    
    <div style="flex: 1;">
      <h4 style="font-size: 1rem; font-weight: 600; color: #1f2937; margin: 0 0 0.25rem 0;">Código por SMS</h4>
      <p style="font-size: 0.875rem; color: #6b7280; margin: 0;">
        {{ phoneNumber ? 'Enviar código a ' + phoneNumber : 'Recibe un código en tu teléfono' }}
      </p>
    </div>
    
    <i class="fas fa-chevron-right" style="color: #9ca3af; font-size: 1rem;"></i>
  </button>

</div>

<!-- Loading -->
<div *ngIf="loading" style="text-align: center; padding: 1rem; background: #f0f9ff; border-radius: 8px; margin-bottom: 1.5rem;">
  <i class="fas fa-spinner fa-spin" style="color: #01abce; font-size: 1.5rem; margin-bottom: 0.5rem;"></i>
  <p style="font-size: 0.875rem; color: #0369a1; margin: 0;">Procesando...</p>
</div>

<!-- Botón Cancelar -->
<button type="button" (click)="cancel()" [disabled]="loading" style="width: 100%; background: white; border: 2px solid #e5e7eb; border-radius: 8px; padding: 0.875rem 1.5rem; color: #6b7280; font-size: 0.9375rem; font-weight: 600; cursor: pointer; transition: all 0.2s;" onmouseover="if(!this.disabled) { this.style.borderColor='#9ca3af'; this.style.color='#374151'; }" onmouseout="if(!this.disabled) { this.style.borderColor='#e5e7eb'; this.style.color='#6b7280'; }">
  <i class="fas fa-arrow-left" style="margin-right: 0.5rem;"></i>
  Cancelar
</button>

</div>
